import State from 'store/State';
import { useSelector } from 'react-redux';
import { selectRpcStreamingWidgetStreamState } from 'widgets/store/rpcStream/selectors';
import { ExpertiseStreamState } from './ExpertiseStreamState';
import { useWidgetContext } from 'widgets/WidgetContext';
import { WidgetType } from 'widgets/WidgetType';

export const selectExpertiseWidgetData = (
    state: State,
    widgetType: WidgetType,
    widgetKey: string
) =>
    selectRpcStreamingWidgetStreamState<ExpertiseStreamState>(
        state,
        widgetType,
        widgetKey
    )?.orderData;

export const useSelectExpertiseData = () => {
    const { widgetType, widgetKey } = useWidgetContext();
    return useSelector((state: State) =>
        selectExpertiseWidgetData(state, widgetType, widgetKey)
    );
};
